import { Plugin } from '@nuxt/types'
import { isMobile } from '~/lib/utils/utils'

declare global {
  interface Window {
    dataLayer: any
  }
}

type EventOptions = { [key: string]: any }

interface GTM {
  init: (id: string) => void
  push: (options: EventOptions) => void
}

declare module '@nuxt/types' {
  interface Context {
    $gtm: GTM
  }
}

const GTMPlugin: Plugin = ({ $gtm, $config, $auth, $featureFlags, store }) => {
  if (!$auth.loggedIn) {
    return
  }

  let gtmInitialized = false

  const pushUserDataToGTM = () => {
    const user = $auth.user

    if (!user?.meta || !user?.profile) {
      return false
    }

    const options: EventOptions = {
      affid: user.meta.affid || 'none',
      isMobile: isMobile(),
      fset: user.fset?.name,
      SRV: user.meta.srv,
      url: window.location.pathname,

      // account props
      email: user.email,
      account: user.id,
      member: !!user.membership,

      fname: user.profile.firstName,
      lname: user.profile.lastName,
      phone: user.profile.phone,
      schoolLevel: user.profile.schoolLevel?.name,
      subscriptionType: user.meta.membershipStatus,
      submittedApplications: user.meta.scholarshipStat.applicationCount,
      eligibleScholarships: user.meta.scholarshipStat.eligibleCount
    }

    if (user.membership) {
      options.packagePrice = user.membership.price
      options.packageId = user.membership.id
      options.packageName = user.membership.name
    }

    options.features = $featureFlags?.getAllForGTM?.() ?? {}

    $gtm.push(options)

    if (!gtmInitialized && window && $config.gtm.id) {
      $gtm.init($config.gtm.id)
      gtmInitialized = true
    }

    return true
  }

  // Try to push data immediately if already loaded
  pushUserDataToGTM()

  // Watch for any user changes (including initial load and membership updates)
  store.watch(
    () => $auth.user,
    () => {
      pushUserDataToGTM()
    },
    { deep: true }
  )
}

export default GTMPlugin
